import StepElementsSidebar from './StepElementsSidebar';
import StepEditorHeader from './StepEditorHeader';
import StepMobilePreview from './StepMobilePreview';
import StepBlockConfigPanel from './StepBlockConfigPanel';
import { useState, useEffect, useCallback } from 'react';
import { DndContext, useSensor, useSensors, closestCenter } from '@dnd-kit/core';
import { PointerSensor } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
 
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { v4 as uuidv4 } from 'uuid';
  
 
export default function StepEditor({ node, onClose, funnel, onNodeChange, data, 
  setConfigPanelOpen, configPanelOpen, setEditingNodeId, updateNode, funnelNodes, setNodes, nodes, updateNode2, settingsFunnel, setSettingsFunnel   }) {
    const [blocks, setBlocks] = useState([...(node.data?.blocks || [])]);
   
    const [draggedSidebarBlock, setDraggedSidebarBlock] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeId, setActiveId] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [dragPosition, setDragPosition] = useState({ x: 0, y: 0 });
    const [showGhostBlock, setShowGhostBlock] = useState(false);
    const [el, setEl] = useState(null);
    const [dragingElement, setDragingElement] = useState(null);
    const [haveTempBlock, setHaveTempBlock] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [isOverDropzone, setIsOverDropzone] = useState(false);
    const [stepTitle, setStepTitle] = useState(node.data.title);
    const [editingBlock, setEditingBlock] = useState(null);
    const [updateEditingBlock, setUpdateEditingBlock] = useState(null);

    const TEMP_BLOCK_ID = 'temp-block';

    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: {
          distance: 5,
        },
      })
    ); 

    function handleDragStart(event) {
      const { active } = event;
      setActiveId(active.id);
      setIsDragging(true);
      
      if (active.data.current?.fromSidebar) {
        setDraggedSidebarBlock(active.data.current.element);
      }
    }
  

    function handleDragOver(event) {

      const { active, over } = event;
  

     if(!isDragging){
      return;
     }
     
      if (active?.data?.current?.fromSidebar && over) {
        const overIndex = blocks.findIndex(b => String(b.id) === String(over.id));
        // Se já tem temp block, só reposiciona ele
        let newBlocks = [...blocks];
        let tempIndex = newBlocks.findIndex(b => b.id === TEMP_BLOCK_ID);

        // Remove o temp block se já existir
        if (tempIndex !== -1) newBlocks.splice(tempIndex, 1);

        // Crie um temp block simples (você pode colocar mais coisas se quiser)
        const tempBlock = {
          id: TEMP_BLOCK_ID,
          type: active.data.current.element.type,
          label: active.data.current.element.label,
          icon: active.data.current.element.icon,
          temp: true,
        };

        // Insere o tempBlock na posição correta
        const insertAt = overIndex === -1 ? newBlocks.length : overIndex;
        newBlocks.splice(insertAt, 0, tempBlock);

        setBlocks(newBlocks);
        setHaveTempBlock(true);
      }
    }

    
    function handleDragEnd(event) {
      const { active, over } = event;
    
      // Nenhum destino válido (drop fora da área)
      if (!over) {
        setDraggedSidebarBlock(null);
        setActiveIndex(null);
        setActiveId(null);
        setIsDragging(false);
        return;
      }
      
      // Drop vindo da sidebar
      if (active.data.current?.fromSidebar) {

        // INSERT_YOUR_CODE
        // Remove the temp block if it exists before inserting the new block
     
        const overIndex = blocks.findIndex(b => String(b.id) === String(over.id));
        const insertAt = overIndex === -1 ? blocks.length : overIndex;
        const newBlock = { 
          ...active.data.current.element, 
          id: `block-${Date.now()}-${Math.random()}`, // ID sempre único!
          
          config: {},
        };
        const newBlocks = [
          ...blocks.slice(0, insertAt),
          newBlock,
          ...blocks.slice(insertAt),
        ];
        const newBlocks2 = newBlocks.filter(b => b.id !== "temp-block");
        setBlocks(newBlocks2);
        const updatedNode = {
          ...node,
          data: { 
            ...node.data,
            blocks: newBlocks2 
          }
        };

          // Update the node in the funnel
          const updatedNodes = funnelNodes.map(n => 
            n.id === node.id ? updatedNode : n
          );
          
          setNodes(updatedNodes);
          onNodeChange(node.id, updatedNode.data);
      } else if (active.id !== over.id) {
        // É um bloco sendo reordenado

       
        const oldIndex = blocks.findIndex(b => String(b.id) === String(active.id));
        const newIndex = blocks.findIndex(b => String(b.id) === String(over.id));
        if (oldIndex !== -1 && newIndex !== -1) {
          const newBlocks = arrayMove(blocks, oldIndex, newIndex).filter(b => b.id !== TEMP_BLOCK_ID);
          setBlocks(newBlocks);
          
          // Update the node with new blocks while preserving other node data
          const updatedNode = {
            ...node,
            data: { 
              ...node.data,
              blocks: newBlocks 
            }
          };
          
          // Update the node in the funnel
          const updatedNodes = funnelNodes.map(n => 
            n.id === node.id ? updatedNode : n
          );
          
          setNodes(updatedNodes);
          onNodeChange(node.id, updatedNode.data);
       

        }
      }
      setDraggedSidebarBlock(null);
      setActiveIndex(null);
      setActiveId(null);
      setIsDragging(false);
      setEditingBlock(null);
      setConfigPanelOpen(false);
      
    }
    

    const handleAddBlock = (blockType) => {
      // Implemente a lógica para adicionar um bloco
    };

    const handleBack = () => {
      onClose();
    };

    const handleBlockSelect = (blockId) => {
      // Implemente a lógica para selecionar um bloco
    };

    const handleBlockEdit = (blockId) => {
      // Implemente a lógica para editar um bloco
       
    };



    const handleBlockConfigChange = (blockId, changes) => {
      // Implemente a lógica para alterar as propriedades de um bloco
    };
 
    function duplicateBlock(block) {

     


      const newBlock = { ...block, id: `${block.type}-${uuidv4()}` };

      if(block.type === 'quiz'){
        newBlock.options = block.options.map(opt => ({ ...opt, id: `${opt.type}-${uuidv4()}` }));
      }

      if(block.type === 'cards'){
        newBlock.cards = block.cards.map(card => ({ ...card, id: `${card.type}-${uuidv4()}` }));
      }

      if(block.type === 'levels'){
        newBlock.levels = block.levels.map(level => ({ ...level, id: `${level.type}-${uuidv4()}` }));
      }

      setBlocks(prev => {
        const idx = prev.findIndex(b => b.id === block.id);
        if (idx === -1) return prev;
        const newArr = [...prev];
        newArr.splice(idx + 1, 0, newBlock);
        return newArr;
      });
    
      // Insert the new block immediately after the duplicated block in the current blocks array
      const idx = node.data.blocks ? node.data.blocks.findIndex(b => b.id === block.id) : -1;
      let updatedBlocks;
      if (idx !== -1) {
        updatedBlocks = [
          ...node.data.blocks.slice(0, idx + 1),
          newBlock,
          ...node.data.blocks.slice(idx + 1)
        ];
      } else {
        updatedBlocks = node.data.blocks ? [...node.data.blocks, newBlock] : [newBlock];
      }

      const updatedNode = {
        ...node,
        data: { 
          ...node.data,
          blocks: updatedBlocks 
        }
      };
      onNodeChange(node.id, updatedNode.data);
         
      setConfigPanelOpen(false);
    }

    function handleBlockDelete(blockId) {
      setConfigPanelOpen(false); 
      setEditingBlock(null);
      setBlocks(prev => {
        const idx = prev.findIndex(b => b.id === blockId);
        if (idx === -1) return prev;
        const newArr = [...prev];
        newArr.splice(idx, 1);
        return newArr;
      });
      const newBlocks = blocks.filter(b => b.id !== blockId);
      const updatedNode = {
        ...node,
        data: { 
          ...node.data,
          blocks: newBlocks 
        }
      };
      onNodeChange(node.id, updatedNode.data);
 
      setConfigPanelOpen(false);
    }
 

 

    function updateBlock(blockId, item, value) {
     
      
      const idx = blocks.findIndex(b => b.id === blockId);
      if (idx !== -1) {
        // Create new blocks array instead of mutating
        const newBlocks = [...blocks];
        newBlocks[idx] = { ...newBlocks[idx], [item]: value };
        
        // Update local state
        setBlocks(newBlocks);
        setEditingBlock(prev => ({ ...prev, [item]: value }));
        
        // Update the node with the new blocks
        updateNode2(node.id, {
          ...node.data,
          blocks: newBlocks
        });
  
        
      
      }
    }
 
    function updateStepSettings(settings){
      const updatedNode = {
        ...node,
        data: { 
          ...node.data,
          ...settings
        }
      };
      onNodeChange(node.id, updatedNode.data);
    }
    
 
    
    return (
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragOver={handleDragOver}
        onDragEnd={handleDragEnd}
      > 
        <div
          className="flex flex-col h-full w-[50%]"
          style={{
            boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            overflow: 'hidden',
            zIndex: 1000,
          }}
        >
          {/* Header on top */}

            <StepEditorHeader node={node} onBack={handleBack}  updateStepSettings={updateStepSettings} />
          
          
        
          {/* Main content: sidebar left, preview right */}
          <div className="flex flex-1 h-full w-full">
            {/* Sidebar on the left */}
            <SortableContext items={blocks.map(b => String(b.id))} strategy={verticalListSortingStrategy}>

         
            <div className="flex flex-col h-full w-full" style={{ minWidth: 220, maxWidth: 500,  background: 'white' }}>
              
            {configPanelOpen ? (
              <StepBlockConfigPanel
                blocks={blocks}
                setBlocks={setBlocks}
                node={node}
                onNodeChange={onNodeChange}
                 editingBlock={editingBlock}
                setEditingBlock={setEditingBlock} 

                setConfigPanelOpen={setConfigPanelOpen}
                updateBlock={updateBlock}
                nodes={nodes}
                updateNode={updateNode}
              />
            ) : 
                <StepElementsSidebar
                
                  showGhostBlock={showGhostBlock}
                  setShowGhostBlock={setShowGhostBlock}
                  setEl={setEl}
                  blocks={blocks}
                  setBlocks={setBlocks}
                  setDragingElement={setDragingElement}
                  setActiveIndex={setActiveIndex}
                  haveTempBlock={haveTempBlock}
                  setHaveTempBlock={setHaveTempBlock}
                  node={node}
                  onNodeChange={onNodeChange}
                  updateNode={updateNode}
                  funnel={funnel} 
                  settingsFunnel={settingsFunnel}
                  setSettingsFunnel={setSettingsFunnel}
                  
                  />
                   }
            </div>
            {/* Preview on the right */}
            <div className="flex flex-1 flex-col h-full items-center justify-center bg-white" id="drop-zone">
              <StepMobilePreview
                blocks={blocks}
                onBlockSelect={handleBlockSelect}
                selectedBlockId={node.data.selectedBlockId}
                setEditingNodeId={setEditingNodeId}
                node={node}
                settingsFunnel={settingsFunnel}
             

                setBlocks={setBlocks}
                setNodes={setNodes}
                nodes={nodes}
                funnel={funnel}
                selectedStepId={node.id}
                
                draggedSidebarBlock={draggedSidebarBlock}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                showGhostBlock={showGhostBlock}
                setShowGhostBlock={setShowGhostBlock}
                el={el}
                dragingElement={dragingElement}
                haveTempBlock={haveTempBlock}
                setConfigPanelOpen={setConfigPanelOpen} 
                editingBlock={editingBlock}
                setEditingBlock={setEditingBlock}
                duplicateBlock={duplicateBlock}
                handleBlockDelete={handleBlockDelete} 
                updateEditingBlock={updateEditingBlock}
              />
            </div>
            </SortableContext>
          </div>
        </div>  
     
      </DndContext>
    );
  }